import {
  CompanyAttributes,
  DocumentClassAttributes,
  MaterialStockAttributes,
  OrderAttributes,
  OrderDetailAttributes,
  OrderExtraStatusAttributes,
  SubRouteAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonModule, DecimalPipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule, Sort } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, Router } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import {
  IPaginationResultFrequencies,
  IRequestResult,
} from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { SALES_ORDERS_LIST_TITLE } from "app/modules/components/sales/order-list-components/exports/sales-orders-list.constants";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { LogModalComponent } from "app/modules/shared/log-modal/log-modal.component";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { validateOrdersByAction } from "app/utils/document-class-validation";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { DateTime } from "luxon";
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  lastValueFrom,
  skip,
  Subject,
  Subscription,
  take,
  takeUntil,
} from "rxjs";
import { OrderTableComponent } from "../../assistant/delivery/loads/components/order-table/order-table.component";
import { LoadsService } from "../../assistant/delivery/loads/loads.service";
import { CompanyService } from "../../configuration/company/company.service.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "../../filters/documents-filters/documents-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { DateHelper } from "app/utils/date.helper";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { BusinessPartnerDisplayComponent } from "app/shared/components/business-partner-display/business-partner-display.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { ImportButtonComponent } from 'app/shared/components/excel-import';
import { ImportConfig } from 'app/shared/components/excel-import/interfaces/import-config.interface';
import { ImportApiResponse } from 'app/shared/components/excel-import/interfaces/import-response.interface';
import { ExcelGeneratorService } from 'app/shared/components/excel-import/services/excel-generator.service';
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { ReprintButtonComponent } from "app/modules/shared/reprint-button/reprint-button.component";
import { MaterialsManagementFiltersComponent } from "../../filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { TypeRejectEnum } from "../../shared/form-appro-reject/type-document.enum";
import { AddOrderDetailComponent } from "../add-order-detail/add-order-detail.component";
import { CancelOrderComponent } from "../cancel-order/cancel-order.component";
import { MasterUserInterface } from "../order-generate/interfaces/master-user.interface";
import { OrdersCreationService } from "../order-generate/order-generate.service";
import { OrdersListService } from "../order-list-components/order-list.service";
import { SelectOrderDetailComponent } from "../select-order-detail/select-order-detail.component";
import { IUpdateOrder, IUserApprovalResponse } from "../update-order/interfaces/update-order.interface";
import { UpdateOrderComponent } from "../update-order/update-order.component";
import { UpdateOrderService } from "../update-order/update-order.service";
import { SalesOrdersListExport } from "./exports/sales-orders-list.export";
import { OrderLogModalComponent } from "../../reports/historic/order-customer-log/order-customer-log-modal/order-customer-log-modal.component";
import { UnitMeasureDisplayComponent } from "../../../../shared/components/unit-measure-display/unit-measure-display.component";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { AuditLogViewerService } from "app/shared/services/audit-log-viewer.service";
import { AUDIT_LOG_COLLECTIONS } from "app/shared/components/audit-log-viewer/audit-log-collections.constants";
import { HasPermissionPipe, PermissionDirective, PermissionService } from "app/core/permission";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";
import { SALES_DOCUMENT_PERMISSIONS } from "app/common/constants/permission";

@Component({
  selector: "app-order-list",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatRadioModule,
    MatAutocompleteModule,
    OrderTableComponent,
    FilterComponent,
    DecimalFormatPipe,
    DocumentFlowButtonComponent,
    FilterSectionComponent,
    StatusFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    MaterialsManagementFiltersComponent,
    HoverMenuDirective,
    ImportButtonComponent,
    UserRouteDisplayComponent,
    BusinessPartnerDisplayComponent,
    CompanyCurrencyPipe,
    ReprintButtonComponent,
    UnitMeasureDisplayComponent,
    PermissionDirective,
    HasPermissionPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    DecimalPipe,
    SalesOrdersListExport,
    ExcelGeneratorService,
  ],
  templateUrl: "./order-list.component.html",
  styleUrl: "./order-list.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class OrderListComponent implements OnDestroy {
  readonly PERMISSIONS = SALES_DOCUMENT_PERMISSIONS.ORDERS;

  getCode = getCode;
  projectName = environment.projectName;

  StatusEnum = StatusEnum;
  OrderStatusERPEnum = OrderStatusERPEnum;
  DocumentTypeEnum = DocumentTypeEnum;

  displayedColumns: string[] = [
    "det",
    "check",
    "status",
    "statusERP",
    "type",
    "trip",
    "routeUser",
    "businessPartner",
    "documentNumber",
    "class",
    //'date',
    "subTotal",
    //'surcharge', 'discount', 'tax',
    "total",
    "creation",
    //'documentStatus',
    "actions",
  ];
  dataSource = new MatTableDataSource<OrderAttributes>([]);

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  selection = new SelectionModel<any>(true, []);
  selectedOrder: OrderAttributes | null = null;

  //DETAIL 1 Posiciones del pedido
  displayedColumnsDetail1: string[] = [
    "note",
    "material",
    "warehouse",
    "soldQuantity",
    "unitPrice",
    "subTotal",
    "totalSurcharges",
    "totalDiscounts",
    "totalTaxes",
    "total",
    "actions",
  ];
  dataSourceDetail1 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail1") sortDetail1: MatSort;

  //DETAIL 2 Entrega
  displayedColumnsDetail2: string[] = [
    "material",
    "warehouse",
    "soldQuantity",
    "confirmedQuantity",
    "deliveredQuantity",
    "relatedDocuments",
  ];
  dataSourceDetail2 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail2") sortDetail2: MatSort;

  //DETAIL 3 Factura
  displayedColumnsDetail3: string[] = [
    "material",
    "warehouse",
    "soldQuantity",
    "invoicedQuantity",
    "invoicedPrice",
    "invoicedDiscount",
    "invoice",
  ];
  dataSourceDetail3 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail3") sortDetail3: MatSort;

  companyList: CompanyAttributes[] = [];
  UMPActive: boolean;

  //Filter
  selectedStartDate: Date;
  selectedEndDate: Date;
  dateRange: FormGroup;

  //Filter
  selectedStartDateEnd: Date;
  selectedEndDateEnd: Date;
  dateRangeDelivery: FormGroup;

  //Filter
  selectedStartDateLoad: Date;
  selectedEndDateLoad: Date;
  dateRangeLoad: FormGroup;

  // selectedStatusERP: number = 0;
  // Selección múltiple
  selectedStatusERP: number[] = [];

  // Controlador de búsqueda
  statusFilterCtrl = new FormControl();

  // Estados filtrados
  filteredStatusERP: BehaviorSubject<any[]> = new BehaviorSubject([]);

  // Estados de selección
  isStatusIndeterminate = false;
  isStatusChecked = false;

  private _onDestroy = new Subject<void>();

  // selectedDocumentClass: string = '0';
  selectedDocumentClass: string[] = [];
  filteredDocumentClasses: Subject<DocumentClassAttributes[]> = new Subject();
  documentClassMultiFilterCtrl: FormControl = new FormControl();
  isIndeterminateDocumentClass: boolean = false;
  isCheckedDocumentClass: boolean = false;
  private _onDestroyDocumentClass = new Subject<void>();

  selectedSeller: string = "0";
  selectedWithTravel: string[] = [];

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  isGlobalSynchronizeAvailable: boolean = false;

  orderStatusErpList = [
    { id: null, name: "Todos" },
    { id: 0, name: "Pedido pendiente" },
    { id: 4, name: "Error enviando a ERP" },
    { id: 1, name: "Pedido enviado a ERP" },
    { id: 2, name: "Pedido recibido por ERP" },
    { id: 3, name: "Pedido creado en ERP" },
  ];

  isOrderListTrip = environment.isOrderListTrip;

  @ViewChild("orderDetailUpdateConfirmationDialog")
  orderDetailUpdateConfirmationDialog!: TemplateRef<any>;

  interval;
  timeInterval = 60000 * 15;
  showInterval: boolean = false;

  companies: CompanyAttributes[] = [];

  @ViewChild("popupTemplate", { read: TemplateRef })
  popupTemplate!: TemplateRef<any>;
  isPopupVisible = false;
  popupText = null;
  popupStyle: any = {};

  selectedSoldTo: string = "0";
  soldToControl = new FormControl("");
  soldToList: any[] = [];
  soldToFilterSelected: any = null;

  selectedShipTo: string = "0";
  shipToControl = new FormControl("");
  shipToList: any[] = [];

  pendingUserName: string = "";

  @ViewChild("pendingOrderByUserModal")
  pendingOrderByUserModal!: TemplateRef<any>;
  dialogRefPendingOrderByUser: MatDialogRef<any>;

  pendingOrders: OrderAttributes[] = [];

  subs: Subscription[] = [];
  ordersToFilter: string[] = [];
  private isInitialized = false; // Flag para prevenir dobles llamadas

  selectWarehouseIds: [] = [];
  warehouseList: WarehouseAttributes[] = [];
  warehouseFilterList: WarehouseAttributes[] = [];
  searchWarehouse = "";

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;

  //Para filtros
  selectedStatuses: number[] = [];

  // Estados ERP
  selectedERPStatuses: number[] = [];

  selectedCustomerType: string[] = [];

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  typeDocument = DocumentTypeEnum.PEDIDO;

  constructor(
    private ordersListService: OrdersListService,
    private readonly updateOrderService: UpdateOrderService,
    private readonly ordersCreationService: OrdersCreationService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly subRouteService: SubRouteService,
    private readonly warehouseService: WarehouseService,
    private readonly documentClassService: DocumentClassService,
    private readonly companyService: CompanyService,
    private readonly loadsService: LoadsService,
    private readonly searchService: SearchService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private readonly cdr: ChangeDetectorRef,
    private salesOrdersListExport: SalesOrdersListExport,
    private viewContainerRef: ViewContainerRef,
    private readonly router: Router,
    private activatedRoute: ActivatedRoute,
    private excelGeneratorService: ExcelGeneratorService,
    private readonly auditLogViewerService: AuditLogViewerService,
    private readonly permissionService: PermissionService,
    private readonly handlerMessage: HandlerMessageService
  ) {
    const today = new Date();
    this.dateRange = this.fb.group({
      start: [today],
      end: [today],
    });
    this.dateRangeDelivery = this.fb.group({
      start: null,
      end: null,
    });
    this.dateRangeLoad = this.fb.group({
      start: null,
      end: null,
    });
    this.selectedStartDate = today;
    this.selectedEndDate = today;
    // this.selectedStartDate.setHours(0, 0, 0, 0);
    this.selectedEndDate.setHours(23, 59, 59, 999);

    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      end_startTrip: [],
      end_endTrip: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
      startDeliveryDate: [],
      endDeliveryDate: [],
      pickerUpload_start: [],
      pickerUpload_end: [],
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit(): void {
    this.onHandleSearch();
    this.subs.push(
      this.activatedRoute.queryParams
        .pipe(
          take(1) // ✅ Solo tomar primer valor para prevenir dobles llamadas
        )
        .subscribe((params) => {
          if (params["orderIds"]) {
            this.ordersToFilter = params["orderIds"]
              ? params["orderIds"].split(",")
              : [];
            //this.search = this.ordersToFilter.toString();
          }

          this.getCompanies().then(() => {
            this.onFilter();
            this.isInitialized = true; // ✅ Marcar como inicializado después de primera carga
          });
        })
    );

    this.fetchDocumentClass();
    // this.getListSeller();
    // this.getListSoldTo(null);
    // this.getListShipTo(null);
    // this.fetchAllWarehouses();
  }

  ngAfterViewInit(): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.VIEW, "No tienes permisos para ver pedidos.")) {
      return;
    }

    this.documentClassMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroyDocumentClass))
      .subscribe(() => {
        this.filterDocumentClasses();
        this.setToggleAllCheckboxStateDocumentClass();
      });

    this.searchControl.valueChanges
      .pipe(
        skip(1), // ✅ Saltar valor inicial
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((filterValue: string) => {
        if (this.isInitialized) {
          // ✅ Solo si ya está inicializado
          this.pageIndex = 1;
          this.search = filterValue;
          this.getList();
        }
      });
    this.filteredStatusERP.next(this.orderStatusErpList);
    this.statusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterStatusERP();
      });

    this.soldToControl.valueChanges
      .pipe(
        skip(1), // ✅ Saltar valor inicial
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        if (!this.isInitialized) return; // ✅ Solo si ya está inicializado

        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }
        this.soldToList = [];
        this.soldToFilterSelected = null;
        this.getListSoldTo(value);

        this.getList();
      });

    this.shipToControl.valueChanges
      .pipe(
        skip(1), // ✅ Saltar valor inicial
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        if (!this.isInitialized) return; // ✅ Solo si ya está inicializado

        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.shipToList = [];
        this.getListShipTo(value);
        this.getList();
      });
  }

  private filterDocumentClasses(): void {
    if (!this.documentClassesList) {
      return;
    }
    let search = this.documentClassMultiFilterCtrl.value;
    if (!search) {
      this.filteredDocumentClasses.next(this.documentClassesList);
      return;
    } else {
      search = search.toLowerCase();
    }
    const filtered = this.documentClassesList.filter((docClass) =>
      docClass.name.toLowerCase().includes(search)
    );
    this.filteredDocumentClasses.next(filtered);
  }

  onDocumentClassSelectionChange(selectedValues: string[]): void {
    this.selectedDocumentClass = selectedValues;
  }

  private setToggleAllCheckboxStateDocumentClass(): void {
    const selectedCount = this.selectedDocumentClass.length;
    const totalCount = this.documentClassesList.length;

    this.isCheckedDocumentClass =
      selectedCount > 0 && selectedCount === totalCount;
    this.isIndeterminateDocumentClass =
      selectedCount > 0 && selectedCount < totalCount;
  }

  filterStatusERP(): void {
    const search = this.statusFilterCtrl.value?.toLowerCase() || "";
    const filtered = this.orderStatusErpList.filter((os) =>
      os.name.toLowerCase().includes(search)
    );
    this.filteredStatusERP.next(filtered);
  }

  onStatusSelectionChange(selected: number[]): void {
    this.selectedStatusERP = selected;
    this.updateStatusSelectionState();
  }

  toggleSelectAllStatuses(isChecked: boolean): void {
    this.selectedStatusERP = isChecked
      ? this.orderStatusErpList.map((os) => os.id)
      : [];
    this.updateStatusSelectionState();
  }

  updateStatusSelectionState(): void {
    const total = this.orderStatusErpList.length;
    const selected = this.selectedStatusERP.length;
    this.isStatusChecked = total > 0 && selected === total;
    this.isStatusIndeterminate = selected > 0 && selected < total;
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  openInterval(event) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE_TIME, "No tiene permisos para modificar el tiempo.")) {
      return;
    }

    //para el html si se quiere activar o no
    if (!event) {
      this.showInterval = false;
    } else {
      this.showInterval = true;
    }
    this.onFilter();
  }

  onFilter() {
    if (this.showInterval) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.getList();

      this.interval = setInterval(() => {
        this.getList();
      }, this.timeInterval);
    } else {
      this.getList();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .pipe(
        skip(1), // Saltar primera emisión (valor inicial)
        debounceTime(300) // Esperar 300ms sin cambios
      )
      .subscribe((term) => {
        if (this.isInitialized) {
          // Solo si ya está inicializado
          this.pageIndex = 1;
          this.search = term;
          this.getList();
        }
      });
  }

  getList() {
    this.synchronizeDates();
    if (this.dateRangeDelivery) {
      this.synchronizeDatesDelivery();
    }
    if (this.dateRangeLoad) {
      this.synchronizeDatesLoad();
    }
    this.isGlobalSynchronizeAvailable = false;
    this.resetSelection();

    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sortDirection === "asc" ? "ASC" : "DESC";

    const hasOrderIds = this.ordersToFilter && this.ordersToFilter.length > 0;
    const hasSearch = this.search && this.search.trim().length > 0;

    let options = {
      currentPage: hasOrderIds || hasSearch ? 1 : this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.searchService.searchTermSync, // Usar searchSync del servicio
      sort: sortField,
      sortDirection: sortDirection,
    };

    let value: string | null = null;
    if (
      this.selectedWithTravel.includes("1") &&
      this.selectedWithTravel.includes("2")
    ) {
      value = "0";
    } else if (this.selectedWithTravel.includes("1")) {
      value = "1";
    } else if (this.selectedWithTravel.includes("2")) {
      value = "2";
    }

    let dataFilter: IFilters = {
      type: DocumentTypeEnum.PEDIDO,

      companyId:
        this.form.get("companyId")?.value?.length > 0
          ? this.form.get("companyId").value
          : null,

      startDate:
        !hasOrderIds && this.form.get("start")?.value
          ? DateHelper.getStartOfDay(this.form.get("start").value)
          : null,
      endDate:
        !hasOrderIds && this.form.get("end")?.value
          ? DateHelper.getEndOfDay(this.form.get("end").value)
          : !hasOrderIds && this.form.get("start")?.value
            ? DateHelper.getEndOfDay(this.form.get("start").value)
            : null,

      startTrip:
        !hasOrderIds && this.form.get("startTrip")?.value
          ? DateHelper.getStartOfDay(this.form.get("startTrip").value)
          : null,
      endTrip:
        !hasOrderIds && this.form.get("endTrip")?.value
          ? DateHelper.getEndOfDay(this.form.get("endTrip").value)
          : !hasOrderIds && this.form.get("startTrip")?.value
            ? DateHelper.getEndOfDay(this.form.get("startTrip").value)
            : null,

      end_startTrip:
        !hasOrderIds && this.form.get("end_startTrip")?.value
          ? DateHelper.getStartOfDay(this.form.get("end_startTrip").value)
          : null,
      end_endTrip:
        !hasOrderIds && this.form.get("end_endTrip")?.value
          ? DateHelper.getEndOfDay(this.form.get("end_endTrip").value)
          : !hasOrderIds && this.form.get("end_startTrip")?.value
            ? DateHelper.getEndOfDay(this.form.get("end_startTrip").value)
            : null,

      startDeliveryDate:
        !hasOrderIds && this.form.get("startDeliveryDate")?.value
          ? DateHelper.getStartOfDay(this.form.get("startDeliveryDate").value)
          : null,
      endDeliveryDate:
        !hasOrderIds && this.form.get("endDeliveryDate")?.value
          ? DateHelper.getEndOfDay(this.form.get("endDeliveryDate").value)
          : !hasOrderIds && this.form.get("startDeliveryDate")?.value
            ? DateHelper.getEndOfDay(this.form.get("startDeliveryDate").value)
            : null,

      pickerUpload_start:
        !hasOrderIds && this.form.get("pickerUpload_start")?.value
          ? DateHelper.getStartOfDay(this.form.get("pickerUpload_start").value)
          : null,
      pickerUpload_end:
        !hasOrderIds && this.form.get("pickerUpload_end")?.value
          ? DateHelper.getEndOfDay(this.form.get("pickerUpload_end").value)
          : !hasOrderIds && this.form.get("pickerUpload_start")?.value
            ? DateHelper.getEndOfDay(this.form.get("pickerUpload_start").value)
            : null,

      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value,
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,

      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,

      withTravel: this.selectedWithTravel[0],

      status:
        !hasOrderIds && this.selectedStatuses?.length > 0
          ? this.selectedStatuses
          : null,
      statusERP:
        !hasOrderIds && this.selectedERPStatuses?.length > 0
          ? this.selectedERPStatuses
          : null,
      typeCustomer:
        !hasOrderIds && this.selectedCustomerType?.length > 0
          ? this.selectedCustomerType
          : null,

      materialGroupId: this.form.get("materialGroupId").value,
      materialId: this.form.get("materialId").value,

      ordersToFilter: hasOrderIds ? this.ordersToFilter : null,
    };

    this.ordersListService.findAllWithCount(options, dataFilter).subscribe({
      next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
        this.dataSource.data = res?.data?.data ?? [];
        this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;

        // Limpiar orderIds después de primer uso (inmediatamente)
        if (hasOrderIds) {
          this.ordersToFilter = [];
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener información de los pedidos.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  public totoUTCISODate(date: Date, isStartOfDay: boolean): string {
    const localDate = new Date(date);

    if (isStartOfDay) {
      localDate.setHours(0, 0, 0, 0);
    } else {
      localDate.setHours(23, 59, 59, 999);
    }

    return localDate.toISOString();
  }

  private getSortField(): keyof OrderAttributes {
    const sortFieldMapping: Record<string, keyof OrderAttributes> = {
      status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",
    };
    return sortFieldMapping[this.sortActive] || "creationDateTime";
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    this.getList();
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  isAllSelected() {
    const validRows = this.dataSource.data.filter((row) =>
      this.validateDataToSynchronize(row)
    );

    const numSelected = this.selection.selected.length;
    const numValidRows = validRows.length;
    return numSelected === numValidRows && numValidRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          if (this.validateDataToSynchronize(row)) this.selection.select(row);
        });
  }

  resetSelection() {
    this.selection.clear();
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1}`;
  }

  onCheckboxChange(event, element?): void {
    let auxSelected = this.selection.selected;
    this.isGlobalSynchronizeAvailable =
      auxSelected.length > 0 &&
      auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
        0;
  }

  async toggleDetails(order: OrderAttributes): Promise<void> {
    if (this.selectedOrder && this.selectedOrder._id === order._id) {
      this.closeDetails();
      return;
    }

    this.ordersListService.findToLoadDocumentUnified(order.serial).subscribe({
      next: async (res) => {
        const isUnified = res?.data && res.data.length > 0;
        this.selectedOrder = { ...order, isUnified };

        this.dataSourceDetail1.data =
          this.selectedOrder.detail && this.selectedOrder.detail.length > 0
            ? this.selectedOrder.detail
            : [];
        this.dataSourceDetail1.sort = this.sortDetail1;
        this.setDeliveredAndInvoicedTables();

        // Obtiene compañía
        const companyFound: CompanyAttributes = this.companies.find(
          (c) => c.id == this.selectedOrder.company?.id
        );
        if (companyFound) this.selectedOrder.company = companyFound;

        // Obtiene almacenes y clase de documento
        const orderStatusId = this.selectedOrder.statusId;
        if (orderStatusId != 0 && orderStatusId != 7 && orderStatusId != 8) {
          await this.getDocumentClass(this.selectedOrder);

          if (
            this.selectedOrder.class["showCurrentStockForMaterials"] === true &&
            !this.selectedOrder["warehousesToUpdate"]
          ) {
            // Obtener la subruta completa
            const subRoute: Partial<SubRouteAttributes> = await lastValueFrom(
              this.subRouteService.findOne(
                this.selectedOrder.subRoute._id.toString()
              )
            ).then((res) => res.data);

            let warehousesIds = [];

            // 1. Primero intentar con almacenes de la subruta
            if (subRoute?.warehouses && subRoute.warehouses.length > 0) {
              warehousesIds = subRoute.warehouses.map((w) => w._id);
            }
            // 2. Si no hay almacenes en subruta, buscar en oficina de venta
            else if (subRoute?.salesOffice || this.selectedOrder.salesOffice) {
              const salesOfficeId =
                subRoute?.salesOffice?._id?.toString() ||
                this.selectedOrder.salesOffice._id.toString();

              const salesOffice: Partial<SalesOfficeAttributes> =
                await lastValueFrom(
                  this.salesOfficeService.findOne(salesOfficeId)
                ).then((res) => res.data);

              if (
                salesOffice?.warehouses &&
                salesOffice.warehouses.length > 0
              ) {
                warehousesIds = salesOffice.warehouses.map((ware) => ware._id);
              }
            }

            // Si se encontraron almacenes (de subruta o de oficina), cargarlos
            if (warehousesIds.length > 0) {
              const filter = {
                officeWarehouse: warehousesIds,
                company: [environment.companyId],
              };

              this.selectedOrder["warehousesToUpdate"] = await lastValueFrom(
                this.warehouseService.filterComboBox(filter)
              ).then((res) => res.data);

              this.getStock(
                this.selectedOrder,
                this.selectedOrder["warehousesToUpdate"]
              );
            }
          }
        }
      },
      error: () => {
        this.snackBar.open("Error al validar el pedido", "Cerrar", {
          duration: 3000,
          panelClass: ["snackbar-error"],
        });
      },
    });
  }

  setDeliveredAndInvoicedTables() {
    let detailAux2 =
      this.selectedOrder.detail && this.selectedOrder.detail.length > 0
        ? this.selectedOrder.detail.filter(
            (od) => od.statusId == StatusEnum.ACTIVE && od.soldQuantity > 0
          )
        : [];
    this.dataSourceDetail2.data = detailAux2.map((detail) => ({
      ...detail,
      deliveryDocument:
        detail.relatedDocuments?.find((doc) => doc.type === "DELIVERY") || null,
    }));
    this.dataSourceDetail2.sort = this.sortDetail2;

    let detailAux3 =
      this.selectedOrder.detail && this.selectedOrder.detail.length > 0
        ? this.selectedOrder.detail.filter(
            (od) => od.statusId == StatusEnum.ACTIVE && od.soldQuantity > 0
          )
        : [];
    this.dataSourceDetail3.data = detailAux3.map((detail) => ({
      ...detail,
      invoiceDocument:
        detail.relatedDocuments?.find((doc) => doc.type === "INVOICE") || null,
    }));
    this.dataSourceDetail3.sort = this.sortDetail3;
  }

  sortData(sort: Sort, tab) {
    let dataTable = this.dataSourceDetail1.data.slice();
    if (tab == "tab1") {
      dataTable = this.dataSourceDetail1.data.slice();
    }
    if (tab == "tab2") {
      dataTable = this.dataSourceDetail2.data.slice();
    }
    if (tab == "tab3") {
      dataTable = this.dataSourceDetail3.data.slice();
    }

    dataTable.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "material":
          return this.compare(a.material?.name, b.material?.name, isAsc);
        case "note":
          return this.compare(a.note, b.note, isAsc);
        case "warehouse":
          return this.compare(a.warehouse?.name, b.warehouse?.name, isAsc);
        case "soldQuantity":
          return this.compare(
            Number(a.soldQuantity),
            Number(b.soldQuantity),
            isAsc
          );
        case "unitPrice":
          return this.compare(Number(a.unitPrice), Number(b.unitPrice), isAsc);
        case "subTotal":
          return this.compare(Number(a.subTotal), Number(b.subTotal), isAsc);
        case "subTotalBeforeTaxes":
          return this.compare(
            Number(a.subTotalBeforeTaxes),
            Number(b.subTotalBeforeTaxes),
            isAsc
          );
        case "totalSurcharges":
          return this.compare(
            Number(a.totalSurcharges),
            Number(b.totalSurcharges),
            isAsc
          );
        case "totalDiscounts":
          return this.compare(
            Number(a.totalDiscounts),
            Number(b.totalDiscounts),
            isAsc
          );
        case "totalTaxes":
          return this.compare(
            Number(a.totalTaxes),
            Number(b.totalTaxes),
            isAsc
          );
        case "total":
          return this.compare(Number(a.total), Number(b.total), isAsc);
        default:
          return 0;
      }
    });

    if (tab == "tab1") {
      this.dataSourceDetail1.data = dataTable;
    }
    if (tab == "tab2") {
      this.dataSourceDetail2.data = dataTable;
    }
    if (tab == "tab3") {
      this.dataSourceDetail3.data = dataTable;
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  showPopup(event: MouseEvent, detail: OrderDetailAttributes) {
    if (!detail.note || detail.note.trim() === "") return;

    this.popupText = detail.note || null;
    this.popupStyle = {
      top: `${event.clientY + 10}px`,
      left: `${event.clientX}px`,
    };

    this.isPopupVisible = true;
    this.viewContainerRef.createEmbeddedView(this.popupTemplate);
  }

  hidePopupWithDelay() {
    setTimeout(() => {
      this.isPopupVisible = false;
      this.viewContainerRef.clear();
    }, 500);
  }

  closeDetails(): void {
    this.selectedOrder = null;
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if (date) {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, "0");
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const seconds = d.getSeconds().toString().padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }
      return `${day}-${month}-${year}`;
    }
    return "--:--:--";
  }

  formatHour(date: string): string {
    if (date) {
      const d = new Date(date);
      const hours = d.getHours().toString().padStart(2, "0");
      const minutes = d.getMinutes().toString().padStart(2, "0");
      const seconds = d.getSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
    return "--:--:--";
  }

  onCompanySelectionChange(companyid: string): void {
    /*if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }*/
  }

  toggleTravel(travel: string): void {
    // Si el rol ya está seleccionado, lo eliminamos
    if (this.selectedWithTravel.includes(travel)) {
      this.selectedWithTravel = this.selectedWithTravel.filter(
        (r) => r !== travel
      );
    } else {
      // Si no está seleccionado, lo agregamos
      this.selectedWithTravel.push(travel);
    }
  }

  clearFilters(): void {
    /*this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();*/
    const today = new Date();
    this.dateRange.reset({ start: null, end: null });
    this.dateRangeDelivery.reset({ start: null, end: null });
    this.dateRangeLoad.reset({ start: null, end: null });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.selectedDocumentClass = [];
    this.selectedStatusERP = [];
    this.selectedWithTravel = [];
    this.selectedSeller = "0";
    this.soldToControl.setValue("");
    this.shipToControl.setValue("");
    this.soldToFilterSelected = null;
    this.form.reset();
    this.selectedStatuses = [];
    this.selectedERPStatuses = [];
    this.selectedCustomerType = [];
  }

  synchronizeDates(): void {
    this.selectedStartDate = this.dateRange.get("start")?.value;
    this.selectedEndDate = this.dateRange.get("end")?.value;
  }

  synchronizeDatesDelivery(): void {
    this.selectedStartDateEnd = this.dateRangeDelivery.get("start")?.value;
    this.selectedEndDateEnd = this.dateRangeDelivery.get("end")?.value;
  }

  synchronizeDatesLoad(): void {
    this.selectedStartDateLoad = this.dateRangeLoad.get("start")?.value;
    this.selectedEndDateLoad = this.dateRangeLoad.get("end")?.value;
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: DocumentTypeEnum.PEDIDO,
    };
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
        this.filteredDocumentClasses.next(this.documentClassesList);
      });
  }

  async getCompanies(): Promise<void> {
    this.companies = [];
    await lastValueFrom(this.companyService.fetchCompanyByEnvIds())
      .then((res) => {
        this.companies = res.data;
        if (res.data.length === 1) {
          this.UMPActive = res.data[0].UMPActive;
        }
      })
      .catch((err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener las compañias.",
          "Cerrar",
          { duration: 3000 }
        );
      });
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los vendedores.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  getListSoldTo(search?): void {
    let dataToSend = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };
    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      this.soldToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  onChangeSoldTo() {
    this.soldToFilterSelected = this.soldToList.find(
      (stl) => stl.id == this.soldToControl.value
    );
    this.shipToControl.setValue("");
    this.getListShipTo();
  }

  getListShipTo(search?): void {
    this.shipToList = [];
    const soldToValue = this.soldToFilterSelected
      ? this.soldToFilterSelected._id
      : null;

    let dataToSend: any = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };

    if (soldToValue) {
      dataToSend.soldToMongoId = soldToValue;
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      this.shipToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  private fetchAllWarehouses(): void {
    this.warehouseService.findToComboBox().subscribe({
      next: (res) => {
        this.warehouseList = res.data;
        this.warehouseFilterList = this.warehouseList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener almacenes.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsWarehouse(event) {
    if (!this.warehouseList) {
      return;
    }
    let search = event;
    if (!search) {
      this.warehouseFilterList = this.warehouseList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.warehouseFilterList = this.warehouseList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  synchronizeOrders(order: OrderAttributes) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.SYNC, "No tiene permisos para sincronizar pedidos.")) {
      return;
    }

    let dataToSendPost = {
      TripIds: [],
      orderIds: [],
      method: "POST",
    };

    let dataToSendPut = {
      TripIds: [],
      orderIds: [],
      method: "PUT",
    };

    if (order) {
      if (order?.externalKeys?.code) {
        dataToSendPut.orderIds.push(order._id.toString());
      } else {
        dataToSendPost.orderIds.push(order._id.toString());
      }
    } else {
      this.selection.selected.forEach((o) => {
        if (o.externalKeys?.code) {
          dataToSendPut.orderIds.push(o._id.toString());
        } else {
          dataToSendPost.orderIds.push(o._id.toString());
        }
      });
    }

    const requests = [];
    if (dataToSendPost.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPost).toPromise()
      );
    }
    if (dataToSendPut.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPut).toPromise()
      );
    }

    if (requests.length === 0) {
      this.snackBar.open(
        "No se encontraron registros pendientes de sincronizar con ERP.",
        "Cerrar",
        { duration: 5000 }
      );
    }

    Promise.all(requests)
      .then(() => {
        this.snackBar.open("Registro sincronizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      })
      .catch((err) => {
        this.snackBar.open(
          err.error.message || "Error al sincronizar con el ERP.",
          "Cerrar",
          { duration: 5000 }
        );
      });
  }

  getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
    const status = list.find((i) => i.type == type);
    return status?.description || "-";
  }

  onUpdateOrder(order: OrderAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tiene permisos para editar pedidos.")) {
      return;
    }

    this.ordersListService.findToLoadDocumentUnified(order.serial).subscribe({
      next: (res) => {
        if (res?.data && res.data.length > 0) {
          this.snackBar.open(
            "No se puede actualizar este pedido porque forma parte de un documento unificado",
            "Cerrar",
            { duration: 4000, panelClass: ["snackbar-warning"] }
          );
          return;
        }
        const dialogRef = this.dialog.open(UpdateOrderComponent, {
          panelClass: "form-modal",
          width: "90%",
          data: order,
          disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.data) {
            const dataTemp = this.dataSource.data.slice();
            dataTemp.forEach((o) => {
              if (String(o._id) === String(result.data._id)) {
                o.address = result.data.address;
                o.expeditionCondition = result.data.expeditionCondition;
                o.note = result.data.note;
                o.statusERP = result.data.statusERP;
                o.statusId = result.data.statusId;
              }
            });
            this.dataSource.data = dataTemp;
            this.cdr.detectChanges();
          }
        });
      },
      error: () => {
        this.snackBar.open("Error al validar el pedido", "Cerrar", {
          duration: 3000,
          panelClass: ["snackbar-error"],
        });
      },
    });
  }

  onCancelOrder(
    order: OrderAttributes,
    orderDetail?: OrderDetailAttributes
  ): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tiene permisos para anular pedidos.")) {
      return;
    }

    const dialogRef = this.dialog.open(CancelOrderComponent, {
      panelClass: "form-modal",
      data: {
        type: orderDetail ? "DETAIL" : "ORDER",
        order: order,
        orderDetail: orderDetail,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          const detailTemp: OrderDetailAttributes[] = result.data.detail.map(
            (d) => {
              const detailFoundInLocal = this.selectedOrder.detail.find(
                (od) => od.position == d.position
              );
              d["stock"] = detailFoundInLocal
                ? detailFoundInLocal["stock"]
                : [];
              d["stockToValidate"] = detailFoundInLocal
                ? detailFoundInLocal["stockToValidate"]
                : undefined;
              return d;
            }
          );
          this.selectedOrder.detail = detailTemp;
          this.dataSourceDetail1.data = this.selectedOrder.detail;
        }
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.reasonForRejection = result.data.reasonForRejection;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        if (orderDetail) this.setDeliveredAndInvoicedTables();
        this.cdr.detectChanges();
      }
    });
  }

  onAddOrderDetail(order: OrderAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tiene permisos para modificar detalles del pedido.")) {
      return;
    }

    const dialogRef = this.dialog.open(AddOrderDetailComponent, {
      panelClass: "form-modal",
      data: {
        order,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.statusERP = result.data.statusERP;
          }
        });
        this.dataSource.data = dataTemp;
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          this.selectedOrder.detail = result.data.detail || [];
          this.dataSourceDetail1.data = this.selectedOrder.detail;
          this.getStock(
            this.selectedOrder,
            this.selectedOrder["warehousesToUpdate"]
          );
          this.setDeliveredAndInvoicedTables();
        }
        this.cdr.detectChanges();
      }
    });
  }

  onChangeWarehouseInOrderDetail(orderDetail: OrderDetailAttributes): void {
    orderDetail["stockToValidate"] = 0;
    if (orderDetail["stock"])
      orderDetail["stockToValidate"] = this.roundToX(
        orderDetail["stock"].find(
          (s: MaterialStockAttributes) =>
            String(s.warehouseId) == String(orderDetail.warehouse._id) &&
            String(s.unitOfMeasureId) ==
              String(orderDetail.soldUnitOfMeasure._id)
        )?.availableStock ?? 0,
        3
      );
    this.cdr.detectChanges();
  }

  onChangeSubTotalInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.soldQuantity < 0) {
      orderDetail.soldQuantity = 0;
      this.snackBar.open("La cantidad no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }

    orderDetail.subTotal = orderDetail.unitPrice * orderDetail.soldQuantity;

    // Calcula descuentos
    orderDetail.totalDiscounts = 0;
    if (orderDetail.discounts && orderDetail.discounts.length > 0) {
      orderDetail.totalDiscounts = orderDetail.discounts.reduce(
        (acc, discount) => {
          switch (discount.type) {
            case "PERCENTAGE":
              return acc + (orderDetail.subTotal * discount.discount) / 100;
            case "AMOUNT":
              return acc + discount.discount;
            default:
              return acc;
          }
        },
        0
      );
    }

    orderDetail.subTotalBeforeTaxes =
      orderDetail.subTotal -
      orderDetail.totalDiscounts +
      orderDetail.totalSurcharges;

    // Calcula impuestos
    orderDetail.totalTaxes = 0;
    if (orderDetail.taxes && orderDetail.taxes.length > 0) {
      orderDetail.totalTaxes = orderDetail.taxes.reduce(
        (acc, tax) =>
          acc + (orderDetail.subTotalBeforeTaxes * tax.percentage) / 100,
        0
      );
    }

    orderDetail.total =
      orderDetail.subTotalBeforeTaxes + orderDetail.totalTaxes;
    this.calculateOrderTotals(order);
  }

  calculateOrderTotals(order: OrderAttributes): void {
    order.subTotal = 0;
    order.totalDiscounts = 0;
    order.totalSurcharges = 0;
    order.subTotalBeforeTaxes = 0;
    order.totalTaxes = 0;
    order.total = 0;

    order.detail.forEach((od) => {
      if (od.statusId == StatusEnum.ACTIVE) {
        order.subTotal += od.subTotal;
        order.totalDiscounts += od.totalDiscounts;
        order.totalSurcharges += od.totalSurcharges;
        order.subTotalBeforeTaxes += od.subTotalBeforeTaxes;
        order.totalTaxes += od.totalTaxes;
        order.total += od.total;
      }
    });
    this.cdr.detectChanges();
  }

  onChangeQuantityInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (
      order.class["makesStockValidation"] &&
      orderDetail["stockToValidate"] &&
      orderDetail.soldQuantity > orderDetail["stockToValidate"]
    ) {
      orderDetail.soldQuantity = orderDetail["stockToValidate"];
      this.snackBar.open(
        "La cantidad no debe ser mayor al disponible.",
        "Cerrar",
        { duration: 3000 }
      );
    }
    orderDetail.baseQuantity =
      orderDetail.soldQuantity * orderDetail.baseConversionFactor;
    if (orderDetail?.material?.UMPActive) {
      orderDetail.pararellQuantity =
        orderDetail.baseQuantity * orderDetail.pararellConversionFactor;
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  onChangePriceInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.unitPrice < 0) {
      orderDetail.unitPrice = 0;
      this.snackBar.open("El precio no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  openOrderDetailUpdateConfirmation(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tiene permisos para modificar detalles del pedido.")) {
      return;
    }

    if (orderDetail["thereIsChanges"])
      this.dialog
        .open(this.orderDetailUpdateConfirmationDialog, {
          data: null,
          panelClass: "form-modal",
          disableClose: true,
        })
        .afterClosed()
        .subscribe((result) => {
          if (result) this.onSaveOrderDetailUpdate(order, orderDetail);
        });
    else orderDetail["isEditMode"] = false;
    this.cdr.detectChanges();
  }

  onSaveOrderDetailUpdate(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    const dataToUpdate: IUpdateOrder = {
      detail: [
        {
          position: orderDetail.position,
          warehouseId: orderDetail.warehouse
            ? String(orderDetail.warehouse._id)
            : null,
          soldQuantity: orderDetail.soldQuantity,
          unitPrice: orderDetail.unitPrice,
        },
      ],
    };

    this.updateOrderService
      .updateOrder(String(order._id), dataToUpdate)
      .subscribe({
        next: (result) => {
          this.snackBar.open("Detalle actualizado con éxito.", "Cerrar", {
            duration: 3000,
          });
          orderDetail["isEditMode"] = false;
          orderDetail["thereIsChanges"] = false;
          if (result && result.data) {
            const dataTemp = this.dataSource.data.slice();
            if (
              this.selectedOrder &&
              String(this.selectedOrder._id) == String(order._id)
            ) {
              const detailTemp: OrderDetailAttributes[] =
                result.data.detail.map((d) => {
                  const detailFoundInLocal = this.selectedOrder.detail.find(
                    (od) => od.position == d.position
                  );
                  d["stock"] = detailFoundInLocal
                    ? detailFoundInLocal["stock"]
                    : [];
                  d["stockToValidate"] = detailFoundInLocal
                    ? detailFoundInLocal["stockToValidate"]
                    : undefined;
                  return d;
                });
              this.selectedOrder.detail = detailTemp;
              this.dataSourceDetail1.data = this.selectedOrder.detail;
            }
            dataTemp.forEach((order) => {
              if (String(order._id) == String(result.data._id)) {
                order.subTotal = result.data.subTotal;
                order.totalDiscounts = result.data.totalDiscounts;
                order.totalSurcharges = result.data.totalSurcharges;
                order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
                order.totalTaxes = result.data.totalTaxes;
                order.total = result.data.total;
                order.detail = result.data.detail;
                order.statusERP = result.data.statusERP;
              }
            });
            this.dataSource.data = dataTemp;
            this.setDeliveredAndInvoicedTables();
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el detalle.",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  async getStock(order: OrderAttributes, warehouses: WarehouseAttributes[]) {
    let dataToSend = {
      materialsIds: order.detail
        .filter((od) => od.statusId == StatusEnum.ACTIVE)
        .map((d) => String(d.material._id)),
      unitMeasureIds: [],
      warehouseIds: warehouses.map((w) => String(w._id)),
    };
    const stock: MaterialStockAttributes[] = await lastValueFrom(
      this.ordersCreationService.fetchStock(dataToSend)
    ).then((res) => res.data[0].data);

    const dateToValidate = new Date();
    dateToValidate.setMonth(
      dateToValidate.getMonth() +
        (order.company["totalMonthsToGroupStockInRouting"] ?? 0)
    );
    order.detail.forEach((od) => {
      od["stock"] = stock.filter(
        (s) => String(s.materialId) == String(od.material._id)
      );
      od["stockToValidate"] = this.roundToX(
        (order.company["groupStockByDateInRouting"] == true
          ? od["stock"]
              .filter(
                (s: MaterialStockAttributes) =>
                  String(s.warehouseId) == String(od.warehouse._id) &&
                  String(s.unitOfMeasureId) ==
                    String(od.soldUnitOfMeasure._id) &&
                  s.lotExpirationDate &&
                  new Date(s.lotExpirationDate).getTime() >=
                    dateToValidate.getTime()
              )
              .reduce((acc, s) => acc + s.availableStock, 0)
          : od["stock"].find(
              (s: MaterialStockAttributes) =>
                String(s.warehouseId) == String(od.warehouse._id) &&
                String(s.unitOfMeasureId) == String(od.soldUnitOfMeasure._id)
            )?.availableStock ?? 0) / od.baseConversionFactor,
        3
      );
    });
    if (
      this.selectedOrder &&
      String(this.selectedOrder._id) == String(order._id)
    )
      this.dataSourceDetail1.data = this.selectedOrder.detail || [];
    this.cdr.detectChanges();
  }

  async getDocumentClass(order: OrderAttributes) {
    const documentClass: DocumentClassAttributes = await lastValueFrom(
      this.documentClassService.findOne(String(order.class._id))
    ).then((res) => res.data);
    if (documentClass) order.class = documentClass;
    this.cdr.detectChanges();
  }

  roundToX(value: number, decimals: number) {
    return parseFloat(value.toFixed(decimals));
  }

  openLogModal(element:OrderAttributes) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.VIEW_LOGS, "No tiene permisos para ver los logs.")) {
      return;
    }

    let dataToModal = {
      documentIdentifier: element.serial,
    };
    this.dialog.open(LogModalComponent, {
      width: "90%",
      data: dataToModal,
      disableClose: true,
    });
  }

  openAuditLog(element: OrderAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.VIEW_AUDIT_LOG, "No tiene permisos para ver el log de modificaciones.")) {
      return;
    }

    this.auditLogViewerService.open({
      documentIdentifiers: { _id: element._id?.toString() },
      entityName: element.serial,
      collectionName: AUDIT_LOG_COLLECTIONS.ORDER,
    });
  }

  validateDataToSynchronize(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "SYNC");
  }

  validateDataToEdit(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "EDIT");
  }

  validateDataToAppOrRejected(order: OrderAttributes) {
    return (
      validateOrdersByAction([order], this.documentClassesList, "APPROVE") ||
      validateOrdersByAction(
        [order],
        this.documentClassesList,
        "APPROVE_GENERATE_NEXT"
      ) ||
      validateOrdersByAction([order], this.documentClassesList, "REJECT")
    );
  }

  validateDataToCopy(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "COPY");
  }

  validateDataToDivide(order: OrderAttributes) {
    return (
      validateOrdersByAction([order], this.documentClassesList, "DIVIDE") &&
      order?.sourceTransactions.length == 0
    );
  }

  //aprobar/rechazar
  openModal(element): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.APPROVE_REJECT, "No tiene permisos para aprobar o rechazar pedidos.")) {
      return;
    }

    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: {
        element: element,
        requeriment: {
          approve: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "APPROVE"
          ),
          approve_generate: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "APPROVE_GENERATE_NEXT"
          ),
          reject: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "REJECT"
          ),
        },
        type: TypeRejectEnum.PEDIDO,
      }, //'PEDIDO'
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .subscribe((result: IUserApprovalResponse | "Close" | undefined) => {
        if (result === undefined || result == "Close") {
        } else {
          if (result) {
            let sendOrder: IUpdateOrder = {
              reasonForRejectionId: result.reasonRejectionId ?? null,
              statusId: result.approve
                ? StatusEnum.ORDER_APPROVED
                : StatusEnum.INACTIVE,
            };

            this.updateAppReje(element, sendOrder);
          }
        }
      });
  }

  updateAppReje(element, result) {
    this.ordersListService.update(element._id, result).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  cloneOrder(element: OrderAttributes, type: string) {
    // the template passes lowercase, so normalise before comparing
    const normalizedCloneType = (type ?? "").toLowerCase() === "divide" ? "divide" : "copy";

    if (normalizedCloneType === "copy" && !this.checkIfHasPermission(this.PERMISSIONS.COPY, "No tiene permisos para copiar pedidos.")) {
      return;
    }

    if (normalizedCloneType === "divide" && !this.checkIfHasPermission(this.PERMISSIONS.SPLIT, "No tiene permisos para dividir pedidos.")) {
      return;
    }

    //type: 'copy', 'divide'
    const dialogRef = this.dialog.open(SelectOrderDetailComponent, {
      data: { order: element, type: type },
      disableClose: true,
      width: "90%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
      }
    });
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  onExportButtonPressed() {
    if (!this.checkIfHasPermission(this.PERMISSIONS.EXPORT_IMPORT, "No tiene permisos para exportar pedidos.")) {
      return;
    }

    if (!this.salesOrdersListExport.canStartTask()) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: {
        title: SALES_ORDERS_LIST_TITLE,
      },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.salesOrdersListExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  goToTravel(element: OrderAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  fetchSoldToName = (soldtoId: string): string => {
    const foundSoldTo = this.soldToList.find(
      (soldTo) => soldTo.id === soldtoId
    );
    if (foundSoldTo) {
      return foundSoldTo.name;
    }
    return "";
  };

  fetchShipToName = (shipToId: string): string => {
    const foundShipTo = this.shipToList.find(
      (shipTo) => shipTo.id === shipToId
    );
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return "";
  };

  showPendingOrdersByUser(order: OrderAttributes, userType: string) {
    let companyId = environment.companyId;

    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sortDirection === "asc" ? "ASC" : "DESC";

    let options = {
      currentPage: 1,
      limitPerPage: 50,
      search: "",
      sort: sortField,
      sortDirection: sortDirection,
    };

    let soldToId = userType == "soldTo" ? order?.soldTo.id ?? null : null;
    let shipToId = userType == "shipTo" ? order?.shipTo.id ?? null : null;

    this.pendingUserName =
      userType == "soldTo" ? order?.soldTo?.name : order?.shipTo?.name;

    this.dialogRefPendingOrderByUser = this.dialog.open(
      this.pendingOrderByUserModal,
      { width: "90%", disableClose: true }
    );

    this.dialogRefPendingOrderByUser.afterClosed().subscribe(() => {
      this.pendingOrders = [];
    });

    this.loadsService
      .findPendingOrdersByBP(
        DocumentTypeEnum.DOCUMENTO_DE_CARGA,
        companyId,
        null,
        soldToId,
        shipToId,
        options
      )
      .subscribe((res) => {
        this.pendingOrders = res?.data?.[0]?.data ?? [];
      });
  }

  openOrderLogModal(
    order: OrderAttributes,
    orderDetail?: OrderDetailAttributes
  ) {
    if (!this.checkIfHasPermission(this.PERMISSIONS.VIEW_LOGS, "No tiene permisos para ver los logs del detalle.")) {
      return;
    }

    this.dialog.open(OrderLogModalComponent, {
      width: "80%",
      data: {
        serial: order.serial,
        position: orderDetail.position,
      },
    });
  }

  goToLoadDocument(element: OrderAttributes) {
    this.ordersListService.findToLoadDocument(element.serial).subscribe({
      next: (res) => {
        if (res.data && res.data.length > 0) {
          const queryParams = { orderIds: res.data[0].serial };
          const urlTree = this.router.createUrlTree(
            ["master", "sales", "load-documents-list"],
            { queryParams }
          );
          const absoluteUrl =
            window.location.origin + this.router.serializeUrl(urlTree);
          window.open(absoluteUrl, "_blank");
        } else {
          this.snackBar.open(
            "No se encontró el documento de carga asociado.",
            "Cerrar",
            { duration: 3000 }
          );
        }
      },
    });
  }

  hasTrip(element: any): boolean {
    return !!element?.trip?.id;
  }

  replaceOrderDetail(
    order: OrderAttributes,
    detail: OrderDetailAttributes
  ): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.UPDATE, "No tiene permisos para reemplazar detalles del pedido.")) {
      return;
    }

    const dialogRef = this.dialog.open(AddOrderDetailComponent, {
      panelClass: "form-modal",
      data: {
        order,
        useRejectionMotive: true,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const deleteData: IUpdateOrder = {
          detail: [
            {
              position: detail.position,
              reasonForRejection: result.reasonRejection?.name,
              reasonForRejectionId: String(result.reasonRejection?._id),
              statusId: StatusEnum.INACTIVE,
            },
          ],
        };

        this.updateOrderService
          .updateOrder(String(order._id), deleteData)
          .subscribe({
            next: (result) => {
              this.handleUpdateUI(order, result.data);
            },
            error: (deleteErr) => {
              this.snackBar.open(
                deleteErr.error.message || "Error eliminando detalle",
                "Cerrar",
                { duration: 5000 }
              );
            },
          });
      }
    });
  }

  private handleUpdateUI(
    order: OrderAttributes,
    updatedOrder: OrderAttributes
  ): void {
    const dataTemp = this.dataSource.data.slice();
    if (
      this.selectedOrder &&
      String(this.selectedOrder._id) === String(order._id)
    ) {
      this.selectedOrder.detail = updatedOrder.detail || [];
      this.dataSourceDetail1.data = this.selectedOrder.detail;
      this.getStock(
        this.selectedOrder,
        this.selectedOrder["warehousesToUpdate"]
      );
    }

    dataTemp.forEach((orderItem) => {
      if (String(orderItem._id) === String(updatedOrder._id)) {
        orderItem.subTotal = updatedOrder.subTotal;
        orderItem.totalDiscounts = updatedOrder.totalDiscounts;
        orderItem.totalSurcharges = updatedOrder.totalSurcharges;
        orderItem.subTotalBeforeTaxes = updatedOrder.subTotalBeforeTaxes;
        orderItem.totalTaxes = updatedOrder.totalTaxes;
        orderItem.total = updatedOrder.total;
        orderItem.detail = updatedOrder.detail;
        orderItem.statusERP = updatedOrder.statusERP;
      }
    });

    this.dataSource.data = dataTemp;
    this.setDeliveredAndInvoicedTables();
    this.cdr.detectChanges();
  }

  // Verify if company can create load document:
  // TODO: This function need to modify when the company service get updated to include the "canCreateLoadDocument".
  getIfCanCreateLoadDocument(element: OrderAttributes): boolean {
    var company = this.companies.find(
      (company) => company.id === element.company.id
    );
    return company?.canCreateLoadDocument;
  }

  getTooltip(el: OrderAttributes): string {
    const rutaCode =
      el?.subRoute?.externalKeys?.code ?? el?.subRoute?.model ?? "-";
    const rutaName = el?.subRoute?.name ?? "-";
    const user = el?.user?.user_login?.username ?? "-";

    const person = el?.responsibleBusinessPartner?.personNumber
      ? `${el.responsibleBusinessPartner.personNumber} - `
      : "";
    const bpCode = el?.responsibleBusinessPartner?.externalKeys?.code ?? "";
    const bpName = el?.responsibleBusinessPartner?.name ?? "-";

    return [
      `Ruta: ${rutaCode} | ${rutaName}`,
      `Usuario: ${user}`,
      `Responsable: ${person}${bpCode} ${bpName}`.trim(),
    ].join("\n");
  }

  // Import/Export Excel functionality
  downloadTemplate(): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS.EXPORT_IMPORT, "No tiene permisos para descargar la plantilla de pedidos.")) {
      return;
    }

    const url = this.ordersListService.getOrderTemplateUrl();
    if (!url) {
      this.snackBar.open("Plantilla no disponible.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    window.open(url);
  }

  onImportCompleted(response: ImportApiResponse): void {
    if (response.success) {
      this.snackBar.open(
        `Importación completada: ${response.totalSuccess} pedidos importados exitosamente`,
        "Cerrar",
        { duration: 5000 }
      );
      this.getList();
    } else {
      this.snackBar.open(
        `Importación completada con errores: ${response.totalSuccess} exitosos, ${response.totalFailed} fallidos`,
        "Cerrar",
        { duration: 5000 }
      );
      if (response.totalSuccess > 0) {
        this.getList();
      }
    }
  }

  onImportError(error: { message: string }): void {
    this.snackBar.open(
      error?.message || "Error durante la importación",
      "Cerrar",
      { duration: 5000 }
    );
  }

  // Date format  for DD/MM/YY or DD/MM/YYYY formats
  dateFormatValidator = (control: FormControl): ValidationErrors | null => {
    if (!control.value) return null;
    const value = String(control.value).trim();
    if (!value) return null;

    // Validate DD/MM/YY or DD/MM/YYYY format
    const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;
    if (!dateRegex.test(value)) {
      return {
        invalidDateFormat: {
          message: "Formato debe ser DD/MM/AA o DD/MM/AAAA",
        },
      };
    }

    // Validate date components
    const [day, month] = value.split("/").map(Number);
    if (day < 1 || day > 31) {
      return { invalidDateFormat: { message: "Día debe estar entre 1 y 31" } };
    }
    if (month < 1 || month > 12) {
      return { invalidDateFormat: { message: "Mes debe estar entre 1 y 12" } };
    }

    return null;
  };

  // Minimum date validator (current date or later, date-only comparison)
  minCurrentDateValidator = (control: FormControl): ValidationErrors | null => {
    if (!control.value) return null;

    const value = String(control.value).trim();
    if (!value) return null;

    // Parse DD/MM/YY or DD/MM/YYYY
    const parts = value.split("/");
    if (parts.length !== 3) return null;

    const [day, month, yearStr] = parts.map(Number);

    // Handle 2-digit year (YY -> YYYY)
    // 00-49 = 2000-2049, 50-99 = 1950-1999
    let year = yearStr;
    if (yearStr < 100) {
      year = yearStr < 50 ? 2000 + yearStr : 1900 + yearStr;
    }

    // Create date at 00:00:00 (date only, no time)
    const inputDate = new Date(year, month - 1, day);
    inputDate.setHours(0, 0, 0, 0);

    // Get current date at 00:00:00
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Compare dates (date-only comparison)
    if (inputDate < today) {
      return {
        minCurrentDate: {
          message: "La fecha debe ser la actual o posterior",
        },
      };
    }

    return null;
  };

  /**
   * Traduce keys del backend a keys del frontend para mapeo correcto de errores
   */
  private translateBackendKey(backendKey: string): string {
    const keyMap: Record<string, string> = {
      partner_code: "partner_code",
      warehouse: "warehouse",
      material_name: "material_name",
      unit_measurement: "unit_measurement",
      precio: "precio",
    };
    return keyMap[backendKey] || backendKey;
  }

  customImportHandler = async (data, metadata): Promise<ImportApiResponse> => {
    try {
      // Generate Excel file from validated data
      const fileName = metadata?.fileName || "pedidos_import.xlsx";
      const sheetName = metadata?.sheetName || "Pedidos";

      const excelFile = await this.excelGeneratorService.generateExcelFile(
        data,
        this.importConfig.columns,
        fileName,
        sheetName
      );

      // Create FormData to send to the API
      const formData = new FormData();
      formData.append("file", excelFile, fileName);
      formData.append("validatedData", JSON.stringify(data));

      if (metadata) {
        formData.append("metadata", JSON.stringify(metadata));
      }

      // Call the import service
      const response = await this.ordersListService
        .importOrdersFromExcel(formData)
        .toPromise();

      this.getList();

      if (response?.message) {
        this.snackBar.open(response?.message, "Cerrar", { duration: 5000 });
      }

      // Transform the response to match ImportApiResponse format
      return {
        success: response?.processResult?.errorCount === 0 ? true : false,
        data: {
          processResult: response?.processResult,
          invalidRecords: response?.invalidRecords,
        },
        totalProcessed: data.length,
        totalSuccess: response?.processResult?.validRecords || 0,
        totalFailed: response?.totalInvalidRecords || 0,
        message: response?.message || "Importación de pedidos completada",
      };
    } catch (err: unknown) {
      const error = err as {
        error: { message: string; errors: string[] };
        message: string;
      };
      this.snackBar.open(
        error.error?.message || "Falló la importación de pedidos.",
        "Cerrar",
        { duration: 5000 }
      );

      const errorMessage =
        error?.error?.message ||
        error?.message ||
        "Error durante la importación";
      const apiErrors = error?.error?.errors || [];

      return {
        success: false,
        totalProcessed: data.length,
        totalSuccess: 0,
        totalFailed: data.length,
        errors: apiErrors.map((err: unknown, index: number) => {
          const error = err as {
            row: number;
            field: string;
            message: string;
            column?: string;
          };
          return {
            row: error?.row || index,
            column: error?.field || error?.column || "general",
            message: error?.message || errorMessage,
            severity: "error" as const,
          };
        }),
        message: errorMessage,
      };
    }
  };

  importConfig: ImportConfig = {
    title: "de pedidos",
    columns: [
      {
        key: "partner_code",
        displayName: "Código Cliente",
        required: true,
        dataType: "string",
        excelColumnName: "Codigo_Cliente",
        validation: [Validators.required, Validators.minLength(1)],
        isIdentifier: true,
        identifierEntity: "business_partner",
        relatedColumns: ["partner_name"],
      },
      {
        key: "partner_name",
        displayName: "Nombre Cliente",
        required: false,
        dataType: "string",
        excelColumnName: "Nombre_Cliente",
      },
      {
        key: "order_date",
        displayName: "Fecha Pedido",
        required: false,
        dataType: "string",
        excelColumnName: "Fecha_Pedido",
        validation: [this.dateFormatValidator, this.minCurrentDateValidator],
        // Default to today's date in DD/MM/YYYY format if Excel cell is empty
        defaultValue: () => DateTime.now().toFormat("dd/MM/yyyy"),
      },
      {
        key: "document_class",
        displayName: "Clase Pedido",
        required: true,
        dataType: "string",
        excelColumnName: "Clase_Pedido",
        validation: [Validators.required],
      },
      {
        key: "material_code",
        displayName: "Código Material",
        required: true,
        dataType: "string",
        excelColumnName: "Codigo_Material",
        validation: [Validators.required],
        isIdentifier: true,
        identifierEntity: "material",
        relatedColumns: ["precio", "material_name", "unit_measurement"],
      },
      {
        key: "material_name",
        displayName: "Nombre Material",
        required: false,
        dataType: "string",
        excelColumnName: "Nombre_Material",
      },
      {
        key: "precio",
        displayName: "Precio",
        required: false,
        dataType: "number",
        excelColumnName: "Precio",
      },
      {
        key: "quantity",
        displayName: "Cantidad",
        required: false,
        dataType: "number",
        excelColumnName: "Cantidad",
        validation: [Validators.min(0.001)],
      },
      {
        key: "unit_measurement",
        displayName: "UM Venta",
        required: false,
        dataType: "string",
        excelColumnName: "UM_Venta",
        validation: [],
      },
      {
        key: "warehouse_code",
        displayName: "Código Almacén",
        required: true,
        dataType: "string",
        excelColumnName: "Almacen",
        validation: [Validators.required],
        isIdentifier: true,
        identifierEntity: "warehouse",
        relatedColumns: ["warehouse_name"],
      },
      {
        key: "warehouse_name",
        displayName: "Nombre Almacén",
        required: false,
        dataType: "string",
        excelColumnName: "Nombre_Almacen",
      },
    ],
    apiEndpoint: "/api/orders/import",
    customImportHandler: this.customImportHandler,
    allowReUpload: true,
    maxFileSize: 10 * 1024 * 1024, // 10MB
    acceptedFileTypes: [".xlsx", ".xls"],

    defaultSortColumn: "partner_code",
    defaultSortDirection: "desc",

    // Pre-validación: valida datos con el backend antes de importar
    preValidation: {
      enabled: true,
      mode: "automatic", // Se ejecuta automáticamente después de cargar el archivo
      required: true, // El usuario no puede omitir la pre-validación
      blockImportOnErrors: false, // NO bloquear import si hay errores de pre-validación
      handler: async (data, metadata, signal) => {
        try {
          // Regenerar Excel con las columnas configuradas (igual que customImportHandler)
          const fileName = metadata?.fileName || "pedidos_prevalidate.xlsx";
          const sheetName = metadata?.sheetName || "Pedidos";

          const excelFile = await this.excelGeneratorService.generateExcelFile(
            data,
            this.importConfig.columns,
            fileName,
            sheetName
          );

          // Crear FormData con el archivo Excel
          const formData = new FormData();
          formData.append("file", excelFile, fileName);

          // Llamar al servicio de pre-validación
          const response = await this.ordersListService
            .preValidateOrdersFromExcel(formData)
            .toPromise();

          // Mapear keys del backend a keys del frontend
          if (response.rows) {
            response.rows = response.rows.map((row) => ({
              ...row,
              // Traducir columnKeys de errores para que coincidan con FormControls
              errors:
                row.errors?.map((err) => ({
                  ...err,
                  columnKey: this.translateBackendKey(err.columnKey),
                })) || [],
              // Mantener relatedColumnsData tal cual (usamos keys del backend directamente)
              relatedColumnsData: {
                ...row?.relatedColumnsData,
                material_name: row.relatedColumnsData?.["material_name"],
                unit_measurement: row.relatedColumnsData?.["unit_measurement"],
                precio: row.relatedColumnsData?.["precio"],
                warehouse_name: row.relatedColumnsData?.["warehouse_name"],
                partner_name: row.relatedColumnsData?.["partner_name"],
              },
            }));
          }

          return response;
        } catch (error) {
          throw error;
        }
      },
      onPreValidationComplete: (result) => {
        console.log("Pre-validación completada:", result);
        if (result.invalidCount > 0) {
          this.snackBar.open(
            `Pre-validación: ${result.validCount} filas válidas, ${result.invalidCount} con errores`,
            "Cerrar",
            { duration: 5000 }
          );
        } else {
          this.snackBar.open(
            `Pre-validación exitosa: ${result.validCount} filas válidas`,
            "Cerrar",
            { duration: 3000 }
          );
        }
      },
      onPreValidationError: (error) => {
        this.snackBar.open(
          "Error en la pre-validación. Por favor, intente nuevamente.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    },
  };

  checkIfHasPermission(permission: string, errorMessage?: string): boolean {
    const hasPermission = this.permissionService.has(permission);

    if (!hasPermission && errorMessage) {
      this.handlerMessage.error({ message: errorMessage });
    }

    return hasPermission;
  }
}